var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Kf'),_c('Container',{staticStyle:{"position":"relative"},attrs:{"boxShadow":'0px 8px 12px 0px rgba(230,230,230,0.5)'}},[_c('Header',{attrs:{"menuList":_vm.menuList}})],1),(_vm.menuList.length)?_c('router-view',{attrs:{"menuList":_vm.menuList}}):_vm._e(),_c('Container',[_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }